import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AvailabilitySlotTypeProvider,
  IconLibrary,
  PageSection,
  StackablePageButtons,
} from '@product-framework/index';
import { FORM_ACTION } from '@ui-framework/index';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../../utils/getSPLevelStackableButtons';
import SpecialSchedules from '../../../../components/Availability/SpecialSchedules';

function SpecialSchedulesPage({ mode = FORM_ACTION.LIST }) {
  const { serviceProviderId, locationId } = useServiceProvider();
  const navigate = useNavigate();
  const { specialScheduleId: selectedScheduleId } = useParams();

  const stackablePageButtons = [
    ...(mode !== FORM_ACTION.EDIT
      ? [
          {
            label: (
              <FormattedMessage
                id="CREATE_SPECIAL_SCHEDULE"
                defaultMessage="Create Special Schedule"
              />
            ),
            Icon: IconLibrary.SpecialSchedule,
            variant: 'contained',
            permissionName: 'CAN_CREATE_SP_AVAILABILITY_SPECIAL_SCHEDULE',
            onClick: () => {
              navigate(
                `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/special-schedules/create`,
              );
            },
          },
        ]
      : []),
    ...(mode !== FORM_ACTION.LIST
      ? [
          {
            label: (
              <FormattedMessage
                id="LIST_SPECIAL_SCHEDULES"
                defaultMessage="List Special Schedules"
              />
            ),
            Icon: IconLibrary.DefaultSchedules,
            variant: 'outlined',
            permissionName: 'CAN_VIEW_SP_AVAILABILITY_SPECIAL_SCHEDULE',
            onClick: () => {
              navigate(
                `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/special-schedules`,
              );
            },
          },
        ]
      : []),
  ];

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_AVAILABILITY_SPECIAL_SCHEDULES"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={
          <FormattedMessage
            id="SERVICE_PROVIDER_LOCATION_AVAILABILITY_SPECIAL_SCHEDULES"
            defaultMessage="Service Provider Location Availability - Special Schedules"
          />
        }
        HeaderContent={
          <StackablePageButtons
            backButton={false}
            buttons={stackablePageButtons}
          />
        }>
        <AvailabilitySlotTypeProvider>
          <SpecialSchedules
            serviceProviderId={serviceProviderId}
            mode={mode}
            selectedScheduleId={selectedScheduleId}
            locationId={locationId}
          />
        </AvailabilitySlotTypeProvider>
      </PageSection>
    </ServiceProviderLayout>
  );
}

const SpecialSchedulesPageObserver = observer(SpecialSchedulesPage);
export default withServiceProvider(SpecialSchedulesPageObserver);
